import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AnalyticsShopcartModule } from './analytics-shopcart.module';
import { ConfigurationService } from './COMMON/services/configuration.service';
import { ImCartService } from './services/cart/im-cart.service';
import { AnalyticsEffects } from './store/analytics.effects';
import { analitycsReducer } from './store/analytics.reducer';
import { ZenitModule } from './ZENIT/zenit.module';

import { IdtEcommerceApiModule } from '@api/idt-ecommerce-api.module';

@NgModule({
    imports: [
        AnalyticsShopcartModule,
        StoreModule.forFeature('analytics', analitycsReducer),
        EffectsModule.forFeature([AnalyticsEffects]),
        CommonModule,
        IdtEcommerceApiModule,
        ZenitModule,
    ],
    providers: [
        ConfigurationService,
        ImCartService,
    ],
})
export class AnalyticsModule { }
